/**
 * Flat caliper-cover set prices. Same dollars for every product — not a
 * Shopify variant lookup. Boogie (Oct 2026):
 *
 *   Full set:           249.99
 *   Front pair or rear: 164.99
 *   6-piece set:        349.99
 *
 * This is the plain set only. The count is fitment set_count (2, 4, or 6),
 * including a string such as "Set of 6". The part number does not choose it.
 *
 * A six-piece product still has one front plate and one rear plate in the
 * scene, same as a set of 4. Engraving, text, upload, color, fill, and bolt
 * line prices match a set of 4. Only the base is 349.99.
 *
 * Approved and licensed logos are $25 per plate. A set of 2 uses the $35
 * pair price (items.json twoPiecePricing) via usesPairAddOnPrices. The MGP
 * logo's line price is 0. Text and an uploaded logo stay $75 per plate.
 * Bolts stay $10. Those lines have no pair price.
 *
 * Option prices from a hidden Shopify collection are deferred.
 */

export const MGP_BASE_PRICES = {
  full: 249.99,
  pair: 164.99,
  six: 349.99,
};

export function readSetCount(value) {
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (typeof value === "string") {
    const match = value.match(/\d+/);
    if (match) return Number(match[0]);
  }
  return undefined;
}

export function setTypeFromFitment(fitment) {
  const setCount = readSetCount(fitment?.set_count);
  if (setCount === 6) return "six";
  if (setCount === 2) return "pair";
  return "full";
}

export function usesPairAddOnPrices(fitment) {
  return readSetCount(fitment?.set_count) === 2;
}

// Order _Finish only. A licensed path does not change the set price.
export function isLicensedEngravingSrc(src) {
  return typeof src === "string" && src.includes("/licensed/");
}

export function cartHasLicensedEngraving(cartData) {
  return (cartData || []).some((item) => item && item.section === "engravings" && isLicensedEngravingSrc(item.previewImg));
}

export function basePriceForFitment(fitment) {
  return MGP_BASE_PRICES[setTypeFromFitment(fitment)];
}
